
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/[subdomain]/rules",
      function () {
        return require("private-next-pages/_subdomains/[subdomain]/rules.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/[subdomain]/rules"])
      });
    }
  